"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.systemUserLastName = exports.systemUserFirstName = void 0;
exports.systemUserFirstName = 'HBT';
exports.systemUserLastName = 'System User';
